module.exports = __webpack_public_path__ + "img/Borlaug_CX_High.c2996487.png";